export const aiJobHistoryFeedKeys = {
  all: ['ai-job-history-feed'] as const,
  list: (params: { ownerKey: string; limit: number }) =>
    [...aiJobHistoryFeedKeys.all, params] as const,
};
